import { filterBarSlice } from './slice';
import * as types from './types';
import * as selectors from './selectors';
import * as constants from './constants';
import * as thunks from './thunks';

const { actions } = filterBarSlice;
export {
  types,
  actions,
  selectors,
  constants,
  thunks,
};

export default filterBarSlice.reducer;
